module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.a17f43cc.ttf";